import {styled} from "@mui/material/styles";
import {Button, Grid, Typography} from "@mui/material";
import ImageComponent from "../Image/Image";
import {Theme} from "@mui/system";
import RoomIcon from "@mui/icons-material/Room";
import PhoneIcon from "@mui/icons-material/Phone";

/**
 * @deprecated
 */
export const LocationCardContainer = styled(Grid)(() => ({
  padding: '0.8em',
  border: '1px solid rgba(238, 238, 238, 1)',
  borderRadius: '0.5em',
  marginBottom: '1em',
  width: '100%'
}));

/**
 * @deprecated
 */
export const LocationCardHeader = styled(Grid)(() => ({
  background: 'rgba(63, 81, 181, 0.08)',
  padding: '0.93em 0.71em',
  gap: '1em'
}));

/**
 * @deprecated
 */
export const LocationCardImgStyles = styled(ImageComponent)(() => ({
  objectFit: 'cover',
  marginTop: '1em',
  width: '100%',
  height: '282px',
  borderRadius: '0.5em',
}));

/**
 * @deprecated
 */
export const LocationCardHeaderTitle = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: '1.1rem',
  fontFamily: "Inter"
}));

/**
 * @deprecated
 */
export const LocationCardStatusContainer: any = styled(Grid, { // typescript is trolling me and this is deprecated so i don't care
  shouldForwardProp: propName => propName !== 'isActive'
})(({theme, isActive}: { theme: Theme, isActive?: boolean}) => ({
  background: isActive ? theme.palette.success.main : theme.palette.error.main,
  color: '#fff',
  padding: '0.2em 0.5em',
  borderRadius: '0.2em',
  width: 'fit-content',
  "& .MuiTypography-body2": {
    fontSize: '0.7rem',
    fontWeight: 500,
    fontFamily: "Inter"
  }
}));

/**
 * @deprecated
 */
export const LocationCardEndBtn = styled(Button)(({theme}) => ({
  marginRight: '1em',
  color: theme.palette.success.main,
}));

/**
 * @deprecated
 */
export const LocationCardDeactiveButton = styled(Button)(({theme}) => ({
  color: theme.palette.error.main,
  borderColor: theme.palette.error.main,
  "&:hover": {
    background: theme.palette.error.main,
    color: '#fff',
  }
}));

/**
 * @deprecated
 */
export const LocationCardMarginTop = styled(Grid)(() => ({
  marginTop: '.8em'
}));

/**
 * @deprecated
 */
export const LocationCardBuyerCardMarginTop = styled(Grid)(() => ({
  paddingTop: '2%'
}));

/**
 * @deprecated
 */
export const LocationCardLabel = styled(Typography)(() => ({
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: "Inter",
  textTransform: 'capitalize',
  lineHeight: '1.43em',
  letterSpacing: '0.01em',
}));

/**
 * @deprecated
 */
export const LocationCardValue = styled(Typography)(() => ({
  textTransform: 'capitalize',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '1.82em',
  letterSpacing: '0.01em',
}));

const IconStyles = ({theme}: { theme: Theme}) => ({
  color: theme.palette.info.main,
  fontSize: '0.9rem',
});
/**
 * @deprecated
 */
export const LocationCardRoomIcon = styled(RoomIcon)(IconStyles);

/**
 * @deprecated
 */
export const LocationCardPhoneIcon = styled(PhoneIcon)(IconStyles);

/**
 * @deprecated
 */
export const LocationCardGap = styled(Grid)(() => ({
  gap: '1em'
}));
